import { Typography } from '@mui/material';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { ComplianceRequiredEvent, TopicMentionEvent } from '../../../../../../../../../../../../../generated/core-api/graphql-react-query';
import DurationFormat from '../../../../../../../../../../../../../utils/formatDuration';
import StyledBox from './styles';

interface SessionEventItemProps {
  sessionEvent: ComplianceRequiredEvent;
  sessionDate: number;
}

function Layout(props: { children: React.ReactNode, count: number }) {
  const { t } = useTranslation('session-event');
  const { children, count } = props;
  return (
    <Typography variant="body1">
      <Trans
        t={t}
        i18nKey="compliance-required.description"
        components={{ 1: <strong /> }}
        values={{ count }}
      />
      {children}
    </Typography>
  );
}

export default function RequiredEventItem(props: SessionEventItemProps) {
  const { sessionEvent, sessionDate } = props;
  const { t } = useTranslation('session-event');
  const duration = Math.max(...sessionEvent.causes.map((cause) => cause.event.date)) - sessionDate;
  const durationFormat = new DurationFormat({ style: 'narrow', timestampFormat: 'millisecond' });
  return (
    <StyledBox>
      {sessionEvent.causes[0].event.__typename === 'ConversationEngagedEvent' && (
        <Layout count={duration}>
          {t('compliance-required.causes.conversationEngagedEvent')}
        </Layout>
      )}
      {
        sessionEvent.causes[0].event.__typename === 'DurationThresholdReachedEvent' && (
          <Layout count={duration}>
            <Trans
              t={t}
              i18nKey="compliance-required.causes.durationThresholdReachedEvent"
              components={{ 1: <strong /> }}
              values={{
                minDuration: durationFormat.format(sessionEvent.causes[0].event.minDuration * 60000),
              }}
            />
          </Layout>
        )
      }
      {
        sessionEvent.causes[0].event.__typename === 'TopicMentionEvent' && (
          <Layout count={duration}>
            <Trans
              t={t}
              i18nKey="compliance-required.causes.topicMentionEvent"
              components={{ 1: <strong /> }}
              values={{
                topics: sessionEvent.causes
                  .filter((cause) => cause.event.__typename === 'TopicMentionEvent')
                  .map((cause) => cause.event as TopicMentionEvent)
                  .map((cause) => cause.topic.text)
                  .join(', '),
              }}
            />
          </Layout>
        )
      }
    </StyledBox>
  );
}
